import { AccountType } from './AccountType';
import { getGravatarUrl } from './Utils';

export default class Account {
  private value: AccountType;

  private avatarUrl: string;
  public constructor(value: AccountType) {
    this.value = value;
  }

  public getFirstName() {
    return this.value.firstName || this.value.email;
  }

  public getLastName() {
    return this.value.lastName || '';
  }

  public getFullName() {
    const firstName = this.getFirstName();
    const lastName = this.getLastName();
    let fullName = firstName;
    if (lastName) {
      fullName += ` ${lastName}`;
    }
    return fullName;
  }

  public getInitials() {
    const firstInitial = this.getFirstName().charAt(0).toUpperCase();
    const lastInitial = this.getLastName().charAt(0).toUpperCase();
    let initials = firstInitial;
    if (lastInitial) {
      initials += `${lastInitial}`;
    }
    return initials;
  }

  public getEmail() {
    return this.value.email;
  }

  public async load() {
    this.avatarUrl = await getGravatarUrl(this.value.email);
  }

  public getAvatar(): string {
    return this.avatarUrl;
  }
}
